import { render, staticRenderFns } from "./DoubleButtonFloatingFrame.vue?vue&type=template&id=6664dcad&scoped=true&"
import script from "./DoubleButtonFloatingFrame.vue?vue&type=script&lang=ts&"
export * from "./DoubleButtonFloatingFrame.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleButtonFloatingFrame.vue?vue&type=style&index=0&id=6664dcad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664dcad",
  null
  
)

export default component.exports